// Common
///////////

// Common sizes
export const SIZE_XSMALL = 'xs'
export const SIZE_SMALL = 'sm'
export const SIZE_MEDIUM = 'md'
export const SIZE_LARGE = 'lg'
export const SIZE_XLARGE = 'xl'
export const SIZE_2XLARGE = '2xl'
export const SIZES = {
  [SIZE_XSMALL]: 'X Small',
  [SIZE_SMALL]: 'Small',
  [SIZE_MEDIUM]: 'Medium',
  [SIZE_LARGE]: 'Large',
  [SIZE_XLARGE]: 'X Large',
  [SIZE_2XLARGE]: '2X Large',
}

// Components
///////////////

// Button sizes
export const BUTTON_SIZE_XSMALL = 'xs'
export const BUTTON_SIZE_SMALL = 'sm'
export const BUTTON_SIZE_MEDIUM = 'md'
export const BUTTON_SIZE_LARGE = 'lg'
export const BUTTON_SIZES = {
  [SIZE_XSMALL]: 'Extra small',
  [SIZE_SMALL]: 'Small',
  [SIZE_MEDIUM]: 'Medium',
  [SIZE_LARGE]: 'Large',
}

// Button variants
export const BUTTON_VARIANT_DEFAULT = 'default'
export const BUTTON_VARIANT_DEFAULT_RED = 'default-red'
export const BUTTON_VARIANT_RED = 'red'
export const BUTTON_VARIANT_GREEN = 'green'
export const BUTTON_VARIANT_BLUE = 'blue'
export const BUTTON_VARIANT_LIGHT_BLUE = 'light-blue'
export const BUTTON_VARIANT_PLAIN = 'plain'
export const BUTTON_VARIANT_PLAIN_WHITE = 'plain-white'
export const BUTTON_VARIANT_LINK = 'link'
export const BUTTON_VARIANT_LINK_RED = 'link-red'
export const BUTTON_VARIANT_LINK_DARK = 'link-dark'
export const BUTTON_VARIANTS = {
  [BUTTON_VARIANT_DEFAULT]: 'Default',
  [BUTTON_VARIANT_DEFAULT_RED]: 'Default (red text)',
  [BUTTON_VARIANT_RED]: 'Red',
  [BUTTON_VARIANT_GREEN]: 'Green',
  [BUTTON_VARIANT_BLUE]: 'Blue',
  [BUTTON_VARIANT_LIGHT_BLUE]: 'Light Blue',
  [BUTTON_VARIANT_PLAIN]: 'Plain',
  [BUTTON_VARIANT_PLAIN_WHITE]: 'Plain White',
  [BUTTON_VARIANT_LINK]: 'Link',
  [BUTTON_VARIANT_LINK_RED]: 'Link Red',
  [BUTTON_VARIANT_LINK_DARK]: 'Link Dark',
}

// Input types
export const INPUT_TYPE_TEXT = 'text'
export const INPUT_TYPE_PASSWORD = 'password'
export const INPUT_TYPE_EMAIL = 'email'
export const INPUT_TYPE_TEL = 'tel'
export const INPUT_TYPE_NUMBER = 'number'
export const INPUT_TYPE_URL = 'url'
export const INPUT_TYPE_TEXTAREA = 'textarea'
export const INPUT_TYPE_DATE = 'date'

// Panel variants
export const PANEL_VARIANT_DEFAULT = 'default'
export const PANEL_VARIANT_LIGHT = 'light'

// Badge variants
export const BADGE_VARIANT_DEFAULT = 'default'
export const BADGE_VARIANT_RED = 'red'
export const BADGE_VARIANT_GREEN = 'green'
export const BADGE_VARIANT_BLUE = 'blue'
export const BADGE_VARIANT_YELLOW = 'yellow'
export const BADGE_VARIANTS = {
  [BADGE_VARIANT_DEFAULT]: 'Default',
  [BADGE_VARIANT_RED]: 'Red',
  [BADGE_VARIANT_GREEN]: 'Green',
  [BADGE_VARIANT_BLUE]: 'Blue',
  [BADGE_VARIANT_YELLOW]: 'Yellow',
}

// Avatar variants
export const AVATAR_VARIANT_DEFAULT = 'gray'
export const AVATAR_VARIANT_COLORED = 'colored'
export const AVATAR_VARIANTS = {
  [AVATAR_VARIANT_DEFAULT]: 'Gray',
  [AVATAR_VARIANT_COLORED]: 'Colored',
}
// Avatar sizes
export const AVATAR_SIZE_XSMALL = 'xs'
export const AVATAR_SIZE_SMALL = 'sm'
export const AVATAR_SIZE_DEFAULT = 'md'
export const AVATAR_SIZE_LARGE = 'lg'
export const AVATAR_SIZE_XLARGE = 'xl'
export const AVATAR_SIZE_2XLARGE = '2xl'
export const AVATAR_SIZES = {
  [AVATAR_SIZE_DEFAULT]: 'Default (medium)',
  [AVATAR_SIZE_XSMALL]: 'Extra small',
  [AVATAR_SIZE_SMALL]: 'Small',
  [AVATAR_SIZE_LARGE]: 'Large',
  [AVATAR_SIZE_XLARGE]: 'Extra Large',
  [AVATAR_SIZE_2XLARGE]: '2 Extra Large',
}
// Avatar statuses
export const AVATAR_STATUS_DEFAULT = 'default'
export const AVATAR_STATUS_READY = 'ready'
export const AVATAR_STATUS_PENDING = 'pending'
export const AVATAR_STATUSES = {
  [AVATAR_STATUS_DEFAULT]: 'Default',
  [AVATAR_STATUS_READY]: 'Ready',
  [AVATAR_STATUS_PENDING]: 'Pending',
}

// Alert variants
export const ALERT_VARIANT_DEFAULT = 'default'
export const ALERT_VARIANT_RED = 'red'
export const ALERT_VARIANT_GREEN = 'green'
export const ALERT_VARIANT_BLUE = 'blue'
export const ALERT_VARIANT_YELLOW = 'yellow'
export const ALERT_VARIANTS = {
  [ALERT_VARIANT_DEFAULT]: 'Default',
  [ALERT_VARIANT_RED]: 'Red',
  [ALERT_VARIANT_GREEN]: 'Green',
  [ALERT_VARIANT_BLUE]: 'Blue',
  [ALERT_VARIANT_YELLOW]: 'Yellow',
}

// Check
export const CHECK_SIZE_DEFAULT = 'md'
export const CHECK_SIZE_SMALL = 'sm'
export const CHECK_SIZES = {
  [CHECK_SIZE_DEFAULT]: 'Default (medium)',
  [CHECK_SIZE_SMALL]: 'Small',
}

// Input
export const INPUT_VARIANT_DENSE_SM = 'dense-sm'
export const INPUT_VARIANT_DENSE = 'dense'
export const INPUT_VARIANT_DEFAULT = 'default'
export const INPUT_VARIANTS = {
  [INPUT_VARIANT_DENSE_SM]: 'Dense (sm)',
  [INPUT_VARIANT_DENSE]: 'Dense',
  [INPUT_VARIANT_DEFAULT]: 'Default',
}

// NavItem
export const NAVITEM_VARIANT_DEFAULT = 'default'
export const NAVITEM_VARIANT_LIGHT_BLUE = 'light-blue'

// Spinner
export const SPINNER_VARIANT_DEFAULT = 'default'
export const SPINNER_VARIANT_WHITE = 'white'

// LoaderDots
export const LOADERDOTS_VARIANT_DEFAULT = 'default'
export const LOADERDOTS_VARIANT_WHITE = 'white'
